import moment from 'moment';

/** 분석명 생성에 필요한 최소 정보 — CompareTarget/UtMatrixOption 모두 이 형태를 만족한다 */
interface RptNmTarget {
  utmNo?: string;
  verNo?: string;
}

/**
 * 리포트 분석명(RPT_NM) 생성 — "{YYYYMMDD} {기준UTM_NO}({VER_NO}), {비교대상UTM_NO}({VER_NO}) 비교분석"
 *
 * 예) "20260909 UTM-2024-001(1), UTM-2024-002(2) 비교분석"
 *
 * 규칙 출처는 두 곳이 같은 내용이다.
 * - ref/html/ut_matrix_rpt_demo.html 212줄 "분석명은 날짜(20260909) UT 번호(두개) 버전 비교분석"
 * - ref/README.md §4 RPT_NM 자동생성(`buildRptNm`)
 *
 * 순수 문자열 조합이라 서버가 다시 만들어도 결과가 같다. 리포트 생성 경로가
 * 두 곳(정합화 Report 목록 / UT Matrix Summary)이라 여기로 모아둔다.
 */
export const buildRptNm = (base: RptNmTarget, target: RptNmTarget, at?: Date): string => {
  const ymd = moment(at).format('YYYYMMDD');
  const label = (m: RptNmTarget) => `${m.utmNo ?? ''}(${m.verNo ?? ''})`;
  return `${ymd} ${label(base)}, ${label(target)} 비교분석`;
};
